<template>
  <!-- <div v-if="rdy"> -->
  <section>
    <div class="skew skew-top mr-for-radius">
      <svg
        class="h-8 md:h-12 lg:h-20 w-full text-gray-50"
        viewBox="0 0 10 10"
        preserveAspectRatio="none"
      >
        <polygon fill="currentColor" points="0 0 10 10 0 10"></polygon>
      </svg>
    </div>
    <div class="skew skew-top ml-for-radius">
      <svg
        class="h-8 md:h-12 lg:h-20 w-full text-gray-50"
        viewBox="0 0 10 10"
        preserveAspectRatio="none"
      >
        <polygon fill="currentColor" points="0 10 10 0 10 10"></polygon>
      </svg>
    </div>
    <div class="py-20 bg-gray-50 radius-for-skewed">
      <div class="container mx-auto px-4">
        <div class="mb-16 flex flex-wrap items-center">
          <div class="w-full lg:w-1/2">
            <span class="text-green-600 font-bold"
              >Цахим сургалтын систем</span
            >
            <h2 class="text-4xl lg:text-5xl font-bold font-heading">
              Боломж & Онцлогууд
            </h2>
          </div>
          <div class="hidden lg:block text-right w-1/2">
            <a
              class="
                inline-block
                py-2
                px-6
                rounded-l-xl rounded-t-xl
                bg-green-600
                hover:bg-green-700
                text-gray-50
                font-bold
                leading-loose
                transition
                duration-200
              "
              href="#"
              >Дэлгэрэнгүй</a
            >
          </div>
        </div>
        <div class="flex flex-wrap -mx-3">
          <div class="mb-8 lg:mb-0 w-full lg:w-1/4 px-3">
          <affix ref="affxMnu" style="" relative-element-selector="#example-content" scroll-affix :offset="{ top: 40, bottom: 40 }">
            <div class="py-4 px-6 bg-white shadow rounded">
              <h4 class="mb-4 text-gray-500 font-bold uppercase">Модулиуд</h4>
              <ul>
                <li v-for="(t, i) in types" :key="i">
                  <a :class="{'text-green-600': t.id==curLocType.id}"
                    @click="initModules(t)" href="#example-content"
                    role="button"
                    class="
                      block
                      py-2
                      px-3
                      mb-2
                      rounded
                      hover:text-green-600 hover:bg-gray-50
                    "
                    >{{ t.s1 }}</a
                  >
                </li>
              </ul>




            </div>
            </affix>
          </div>
          <div class="w-full lg:w-3/4 px-3 flex flex-wrap" id="example-content">

            <div class="w-full mx-auto px-3 text-center">
              <h3 class="mb-4 text-lg lg:text-2xl font-bold font-heading">{{curLocType.s2}}</h3>
            </div>

              <div class="mb-6 w-full lg:w-1/2 px-3" :key="ti" v-for="(t, ti) in tasks.filter(x=>x.st3=='Хэлбэр')">
                <div class="p-6 flex flex-wrap bg-white shadow rounded-lg">
                  <div>
                    <span
                      class="
                        mb-4
                        lg:mb-0
                        mr-6
                        inline-block
                        p-3
                        rounded-lg
                        bg-green-100
                      "
                    >
                      <svg
                        class="h-8 w-8 md:w-12 md:h-12 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        ></path></svg
                    ></span>
                  </div>
                  <div class="w-full lg:w-2/3">
                    <h3 class="mb-2 text-2xl font-bold font-heading text-yellow-600">
                      {{ t.task }}
                    </h3>
                    <p class="text-gray-500">{{ t.f1 }}</p>
                  </div>
                  <!-- <p class="text-gray-500 text-right w-full">{{ t.st3 }}</p> -->
                  <!-- <p class="text-gray-500 text-right w-full">{{t.locType1Name}}</p> -->
                </div>
              </div>
                <div class="w-full px-3 mb-6 text-lg">Боломжууд</div>


                <div class="px-3 mb-4 flex items-start align-middle w-full" :key="`${ti}_b`" v-for="(t, ti) in tasks.filter(x=>x.st3=='Боломж')">
                    <svg class="mr-2 w-5 h-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                      </svg>
                    <div>
                    <!-- <h3 class="mb-1 text-xl lg:text-2xl font-bold">{{t.task}}</h3> -->

                    <p class="text-gray-500 leading-normal">
                      <span class="font-bold">{{t.task}}</span>
                      {{t.f1}}
                    </p>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </div>
    <div class="skew skew-bottom mr-for-radius">
      <svg
        class="h-8 md:h-12 lg:h-20 w-full text-gray-50"
        viewBox="0 0 10 10"
        preserveAspectRatio="none"
      >
        <polygon fill="currentColor" points="0 0 10 0 0 10"></polygon>
      </svg>
    </div>
    <div class="skew skew-bottom ml-for-radius">
      <svg
        class="h-8 md:h-12 lg:h-20 w-full text-gray-50"
        viewBox="0 0 10 10"
        preserveAspectRatio="none"
      >
        <polygon fill="currentColor" points="0 0 10 0 10 10"></polygon>
      </svg>
    </div>
  </section>
  <!-- </div> -->
</template>

<script>
import { request } from "@/api/all";
var _ = require("lodash");
import { Affix } from 'vue-affix';

export default {
  components: {
    Affix,
  },
  props: {
    comp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tasks: [],
      //tasksReal: [],
      taskFilters: [],
      types: [],
      curLocType: {
        id: null,
        s1: null,
        s2: null
      },
      rdy: true,
    };
  },
  mounted() {
    //console.log('blank init id is', this.comp, this.comp.locTypeId1);
    this.init(this.comp.locTypeId1);
  },
  methods: {
    init(locTypeId) {
      //console.log('blank init id is', locTypeId);
      request({
        api: { method: "GET", url: "type/getData" },
        params: { parentId: locTypeId, key: "webItemCategory" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.types = res.data.types;
          //console.log(res.data.types);
          this.initModules(res.data.types[0]);
          this.rdy = true;
        }
      });
    },
    initModules(locType, st3) {
      // if (st3 != undefined) {
      //   this.tasks = this.tasksReal.filter((x) => x.st3 == st3);
      // } else {
        this.tasksReal = [];
        this.tasks = [];
        this.curLocType = locType;
        //console.log("tasks is", locTypeId);
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: 357,
            model: {
              isPublic: true,
              locTypeId1: locType.id,
            },
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.tasks= _.orderBy(res.data.tasks, ["ord"], ["asc"]);
            //this.tasks = res.data.tasks;
            // this.tasksReal = res.data.tasks;
            // let _fltrs = _.uniq(res.data.tasks.map((x) => x.st3));
            // this.taskFilters = _fltrs;
            // console.log(this.taskFilters);
            //this.rdy = true;
           
            
          }
        });
      // }
    },
  },
};
</script>

<style>
.affix{
  position: sticky !important;
}
/*@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap");*/
</style>
